module.exports = __webpack_public_path__ + "static/media/home-lg.b10f9532.svg";